import React from 'react';
import PropTypes from 'prop-types';

import { Div, Text } from '@pinpoint/design-kit';

function Legend({ backgroundColor = 'grey900', children }) {
  return (
    <Div d="flex" m={{ r: '1rem' }} align="center">
      <Div w="1rem" h="1rem" bg={backgroundColor} rounded="lg" />
      <Text w="3.5rem" p={{ x: '0.5rem' }} textWeight="600" textSize="tiny" lineHeight="tiny">
        {children}
      </Text>
    </Div>
  );
}

Legend.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  children: PropTypes.isRequired,
};

Legend.defaultProps = {};

export default Legend;
